import React from "react";
import "../styles/Experience.css";

class Experience extends React.Component {
  render() {
    const experiences = [
      {
        orgUrl: "https://www.gatech.edu/",
        img: "gatech-logo.png",
        period: "FALL 2026 - FALL 2027",
        organization: "Georgia Institute of Technology",
        role: "Electrical and Computer Engineering M.S. Student",
        desc: [],
      },
      {
        orgUrl:
          "https://github.com/MSU-CSE498-SS26-Apple/Setup-Assistant-for-MLX-Mac-Cluster",
        img: "mlxlogo.png",
        period: "SPRING 2026",
        organization: "MSU Capstone project sponsored by Apple",
        role: "Software Developer",
        desc: [
          "Architected and shipped a native macOS application (Swift, SwiftUI, Network.framework) for discovering, visualizing, and orchestrating distributed MLX machine-learning workloads across clusters of Apple Silicon Macs, making multi-device distributed computing accessible for demos, education, and experimentation",
          "Engineered Bonjour-based device discovery and Thunderbolt link detection via IOKit, built an automated Python interpreter discovery and MLX validation system, and hardened cluster networking with TCP connection fixes and rank-aware launch coordination, validating the system with distributed MLX inference workloads",
          "Collaborated with Apple engineers and a six-person capstone team to design the system architecture, ensuring seamless integration with the MLX framework and reliable distributed job launching Mac hardware",
        ],
      },
      {
        orgUrl: "https://www.cse.msu.edu/tart/",
        img: "MSULogo.png",
        period: "SUMMER 2025",
        organization: "Trustworthy and Reliable Technologies Lab (TART)",
        role: "Undergraduate Research Assistant",
        desc: [
          "Architected and deployed production-ready UI for HyperQB, a QBF/SMT-based model checker for hyperproperties, making advanced formal verification accessible through intuitive web and desktop interfaces",
          "Built containerized backend services (Docker, Flask, Gunicorn) and automated CI/CD pipelines (GitHub Actions, GitLab) to streamline releases for UI, backend, docs, and macOS builds",
          "Collaborated with PhD researchers and infrastructure team to architect comprehensive ecosystem streamlining developer workflows, ensuring seamless integration with research artifacts and benchmarks",
        ],
      },
      {
        orgUrl: "https://engineering.msu.edu/",
        img: "MSULogo.png",
        period: "SPRING 2025 - SUMMER 2026",
        organization: "MSU College of Engineering",
        role: "Student Front-end Web Assistant",
        desc: [
          "Migrated and redesigned over 500 pages in Sitecore CMS, enhancing accessibility (WCAG-compliant), visual consistency, and user experience for thousands of site visitors",
          "Created and deployed a production-ready JavaScript browser extension used by the MSU Marketing and Communications team—automating HTML cleanup, article formatting, URL generation, and content tree expansion; reduced time-to-publish by 90%",
          "Engineered a Python + Selenium audit tool to automate QA during CMS migration—enabling keyboard-driven approval flows and CSV-based rejection tracking for Sitecore XP vs. XM Cloud comparisons",
          "Designed a reusable Figma component library to standardize UI design and accelerate page creation workflows across the team",
        ],
      },
      {
        orgUrl: "https://tecnisub.com.br/",
        img: "tecnisub.png",
        period: "SUMMER 2024",
        organization: "TECNISUB",
        role: "Mechanical Design and Software Development Intern",
        desc: [
          "Devised a secure catalog application using React, TypeScript, AWS Amplify, and Tailwind CSS to streamline access to 3D models and technical drawings",
          "Interfaced with a team of five technicians and mechanical engineers to ensure software user-friendliness, technical requirements, and informational needs",
          "Designed and modeled products using CAD software, supporting product development and certification processes while ensuring compliance with technical standards",
        ],
      },
      {
        orgUrl: "",
        img: "redcall.png",
        period: "SPRING 2024 - SUMMER 2024",
        organization: "Redcall",
        role: "Creator/ Developer",
        desc: [
          "Devised a user-friendly mobile notification app for a local blood center leveraging Flutter and Firebase within a 3 month period, aimed at donor engagement by sending timely alerts during critical blood shortages",
          "Spearheaded its Idealization and development, mastering and implementing a tech stack to establish an innovative method for attracting new donors and motivating existing ones",
        ],
      },
      {
        orgUrl: "https://www.msu.edu/",
        img: "MSULogo.png",
        period: "FALL 2022 - SPRING 2026",
        organization: "Michigan State University",
        role: "Computer Science B.S. Student",
        desc: [],
      },
      {
        orgUrl: "https://r3animal.org",
        img: "r3animal.png",
        period: "WINTER 2020 - FALL 2024",
        organization: "R3 Animal",
        role: "Web Developer",
        desc: [
          "Conducted regular website updates to share conservation institution's deeds to over 1000 people monthly",
          "Trained employees on how to conduct simple platform updates by themselves, maximizing posting speeds by 80% and increasing overall content diversity on the website",
        ],
      },
    ];
    return (
      <div className="section" id="experience">
        <div className="work-header">
          <h2>
            MY <span className="italic-thin">JOURNEY </span>SO FAR
            <span className="accent">:</span>
          </h2>
        </div>

        <div className="experience-list">
          <div className="experience-duck-div">
            <p>{new Date().getFullYear()}</p>
            <img className="experience-duck" src="duck.png" />
          </div>
          {experiences.map((exp, i) => {
            return (
              <div
                className={
                  i % 2 === 0
                    ? "experience experience-right"
                    : "experience experience-left"
                }
              >
                <div className="experience-img">
                  <a href={exp.orgUrl}>
                    <img src={exp.img} />
                  </a>
                </div>

                <p className="caption">{exp.period}</p>
                <h3 className="organization">{exp.organization}</h3>
                <p className="caption role">{exp.role}</p>
                {exp.desc.map((e, i) => {
                  return <p>{e}</p>;
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Experience;
